export function replaceRuleMethods(ruleBody) {
  if (ruleBody) {
    ruleBody = ruleBody.replace(/dynamicTableRowCell/g, 'complexTableCell');
    ruleBody = ruleBody.replace(/dynamicTableColumn/g, 'complexTableColumn');
    ruleBody = ruleBody.replace(/staticTableColumn/g, 'tableMatrix');
  }
  return ruleBody;
}
